<h1 mat-dialog-title>Class</h1>
<mat-dialog-content>
    <mat-tab-group mat-align-tabs="start" class="detail-component">
        <mat-tab label="Data">
            <div fxLayout="column" fxLayoutGap="10px">
                <mat-form-field fxFlex>
                    <mat-label i18n="@@title">Title</mat-label>
                    <input matInput i18n-placeholder placeholder="e.g. Loudspeakers" [(ngModel)]="data.title" required />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label i18n="@@description">Description</mat-label>
                    <input matInput i18n-placeholder placeholder="e.g. Loudspeakers passive, active"
                        [(ngModel)]="data.description" required />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label i18n="@@deprecationPeriod">Deprecation Period</mat-label>
                    <input matInput type="number" i18n-placeholder placeholder="e.g. 5"
                        [(ngModel)]="data.deprecationPeriod" required />
                    <span matSuffix>years</span>
                </mat-form-field>
            </div>
        </mat-tab>
        <mat-tab label="History" *ngIf="isEditDialog">
            <app-table-detail-history class="detail-tab" entityName="classes" [entityId]="data._id">
            </app-table-detail-history>
        </mat-tab>
        <mat-tab label="General" *ngIf="isEditDialog">
            <app-table-detail-abstract class="detail-tab" [data]="data"></app-table-detail-abstract>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
<div mat-dialog-actions align="end">
    <button mat-button [disabled]="inProgress" (click)="abort()">Abort</button>
    <button mat-button [disabled]="inProgress" (click)="save()" cdkFocusInitial>Ok</button>
</div>